module.exports = __webpack_public_path__ + "media/images/profile-02-2e9973c53127c90f34aee6aea539a92a.png";